import { booleanField, stringField } from '@/common/utils/form/fieldTypes';

export const show_logo = 'show_logo';
export const show_logo_text = 'show_logo_text';
export const logo = 'logo';
export const logo_text = 'logo-text';

export type ManualsExportType = {
  [show_logo]: boolean;
  [show_logo_text]: boolean;
  [logo]: string | null;
  [logo_text]: string | null;
};

const config = {
  [show_logo]: booleanField(),
  [show_logo_text]: booleanField(),
  [logo]: stringField(),
  [logo_text]: stringField()
};

export default config;
